import React from 'react'
import cn from 'classnames'
import { Dropdown } from '@groovehq/internal-design-system/lib/components'
import { ChevronRight } from '@groovehq/internal-design-system/lib/assets/icons'
import Menu from './Menu'
import { styles } from './styles'

const menuOffset = [-12, 0]

const ButtonWithMenu = ({
  children,
  className,
  overlay,
  isActive,
  open,
  setOpen,
  dataTestId,
}) => {
  return (
    <Dropdown
      overlay={overlay}
      strategy="fixed"
      offset={menuOffset}
      visible={open}
      onVisibleChange={setOpen}
      className="grui p-0"
      css={styles.dropdownContainer}
      autoHeight
    >
      <button
        className={cn(className, {
          active: isActive,
          open,
        })}
        css={styles.button}
        data-test-id={dataTestId}
      >
        {children}
        <ChevronRight />
      </button>
    </Dropdown>
  )
}

ButtonWithMenu.Menu = Menu

export default ButtonWithMenu
